var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFewClouds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4478 23.3055C21.2993 23.3055 22.7982 21.8067 22.7982 19.9552C22.7982 18.1037 21.2993 16.6049 19.4478 16.6049C19.4363 16.6049 19.4248 16.6049 19.4133 16.6049C19.1182 13.9407 16.8527 11.863 14.1003 11.863C11.9268 11.863 10.06 13.1587 9.22433 15.0179C9.1975 15.0179 9.17067 15.014 9.14383 15.014C6.85533 15.014 5 16.8694 5 19.1579C5 21.4464 6.85533 23.3017 9.14383 23.3017",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4136 16.6048C19.2092 14.7601 18.0602 13.1966 16.459 12.4093C17.0947 10.9893 18.5201 10 20.1765 10C22.4249 10 24.2475 11.8226 24.2475 14.071C24.2475 15.2651 23.7334 16.3392 22.9144 17.0838C22.3081 16.4841 21.475 16.1141 20.5559 16.1141C20.1404 16.1141 19.7426 16.1895 19.3755 16.3273C19.3906 16.419 19.4033 16.5116 19.4137 16.6048H19.4136ZM19.6341 16.6099C20.5577 16.6603 21.3813 17.0842 21.9565 17.7332C21.9566 17.7332 21.9566 17.7332 21.9566 17.7332C21.3813 17.0842 20.5578 16.6603 19.6341 16.6099Z",
    fill: "url(#paint0_linear_4805_26852)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5803 23.303C21.3702 23.2335 22.798 21.7623 22.798 19.9553C22.798 18.1038 21.2992 16.6049 19.4477 16.6049H19.4132C19.4028 16.5117 19.3901 16.4192 19.375 16.3274C19.7421 16.1896 20.1399 16.1143 20.5554 16.1143C22.2804 16.1143 23.7026 17.4176 23.8904 19.0966H23.9134C25.0749 19.0966 26.0179 20.0396 26.0179 21.2011C26.0179 22.3626 25.0749 23.3056 23.9134 23.3056L19.5803 23.303Z",
    fill: "#CAD1E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6287 11.2573C24.9759 11.2573 25.2573 10.9759 25.2573 10.6287C25.2573 10.2815 24.9759 10 24.6287 10C24.2815 10 24 10.2815 24 10.6287C24 10.9759 24.2815 11.2573 24.6287 11.2573Z",
    fill: "#FDCA4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6287 14.2573C25.9759 14.2573 26.2573 13.9759 26.2573 13.6287C26.2573 13.2815 25.9759 13 25.6287 13C25.2815 13 25 13.2815 25 13.6287C25 13.9759 25.2815 14.2573 25.6287 14.2573Z",
    fill: "#FDCA4F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6287 11.2573C16.9759 11.2573 17.2573 10.9759 17.2573 10.6287C17.2573 10.2815 16.9759 10 16.6287 10C16.2815 10 16 10.2815 16 10.6287C16 10.9759 16.2815 11.2573 16.6287 11.2573Z",
    fill: "#FDCA4F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6287 17.2573C24.9759 17.2573 25.2573 16.9759 25.2573 16.6287C25.2573 16.2815 24.9759 16 24.6287 16C24.2815 16 24 16.2815 24 16.6287C24 16.9759 24.2815 17.2573 24.6287 17.2573Z",
    fill: "#FDCA4F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6287 9.25733C20.9759 9.25733 21.2573 8.97587 21.2573 8.62867C21.2573 8.28146 20.9759 8 20.6287 8C20.2815 8 20 8.28146 20 8.62867C20 8.97587 20.2815 9.25733 20.6287 9.25733Z",
    fill: "#FDCA4F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4805_26852",
    x1: 17.5993,
    y1: 16.5991,
    x2: 23.0661,
    y2: 11.0933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB63A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CC3B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFewClouds);
export default __webpack_public_path__ + "static/media/few_clouds.8a711605d79fee2df26d1f31516216da.svg";
export { ForwardRef as ReactComponent };